export default "__VITE_ASSET__C2lTBE2l__"